import { addToRecentNavigation } from '../assets/javascript/utils';

export default ({ store }) => {
  store.app.router.beforeEach((to, _from, next) => {
    addToRecentNavigation(to);

    next();
  });
};
